module.exports = __webpack_public_path__ + "img/PGSlot_Lobby_Frame.5c71a36f.png";